import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Hospitalemployees from './components/Hospitalemployees';

const hospitalemployees = (props,{ t }) => (
  <Container>
    <Hospitalemployees {...props} />
  </Container>
);

hospitalemployees.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(hospitalemployees);
